<template>
  <div class="competition-index">
    <commonheader />
    <container></container>
    <!-- <commonfooter /> -->
  </div>
</template>

<script>
import container from './container'
import commonheader from './components/header.vue'
// import commonfooter from "./components/footer.vue";
export default {
  name: 'competitionCenter',
  components: {
    container,
    commonheader,
    // commonfooter
  },
  mounted() {
    console.log('触发了赛事中心INDEX')
    document.getElementById('home_top').style.display = 'none'
  },
}
</script>

<style scoped lang="scss">
.competition-index {
  min-width: 900px;
  /*双击文字、input等，出现的蓝色底色，如何去除*/
  // -moz-user-select: none; /*火狐*/
  // -webkit-user-select: none; /*webkit浏览器*/
  // -ms-user-select: none; /*IE10*/
  /*-khtml-user-select:none;!*早期浏览器*!*/
  // user-select: none;
}
</style>
